import React from 'react';
import classNames from 'classnames';

import Input from './Input';
import Button from './Button';

class TableActions extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            active: false
        };
        this.timeoutID = null;
        this.toggleActive = this.toggleActive.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
    }

    componentWillUnmount() {
        if (this.timeoutID) {
            clearTimeout(this.timeoutID);
        }
    }

    toggleActive() {
        this.setState({active:!this.state.active});
    }

    handleBlur() {
        // Delay execution for other elements to catch 'click' event
        this.timeoutID = setTimeout(() => {
            this.setState({active:false});
        },100);
    }

    render() {
        let {className, children, ...props} = this.props;
        let classes = {
            'table-actions': true,
            active: this.state.active
        };

        return (<td className={classNames(classes, className)} {...props}>
            <Button flat onClick={this.toggleActive} onBlur={this.handleBlur}><i className="material-icons">more_horiz</i></Button>
            <div className="table-actions__buttons">
                {children}
            </div>
        </td>);
    }

}

TableActions.propTypes = {
    className: React.PropTypes.string,
    children: React.PropTypes.node
};

export default TableActions;